const doc = [({"da":({"js":({"competitions":({"choose_team_type":({"grade":"Klassetrin %{class_name}", "start_individually":"Spil individuelt", "start_team":"Spil hold"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;